import { createRouter, createWebHistory } from 'vue-router'
import Login from '@/views/Login/index.vue'
import AuthenticLayout from '@/components/AuthenticLayout.vue'
import { ElMessage } from 'element-plus'

const routes = [
  {
    path: '/login',
    name: '登录',
    component: Login
  },
  {
    path: '/',
    name: 'root',
    redirect: '/home',
    component: AuthenticLayout,
    children: [
      {
        path: '/home',
        name: '首页',
        meta: { requiresAuth: true, roles: ['r_admin', 'r_doctor'] },
        component: () => import('@/views/Home/index.vue')
      },
      {
        path: '/patients',
        name: '患者管理',
        redirect: '/patients/list',
        meta: { requiresAuth: true },
        children: [
          {
            path: '/patients/list',
            name: '患者列表',
            meta: { requiresAuth: true, roles: ['r_admin', 'r_doctor'] },
            component: () => import('@/views/Patients/index.vue')
          },
          {
            path: '/patients/:sn',
            name: '患者详情',
            meta: { requiresAuth: true, roles: ['r_admin', 'r_doctor'] },
            component: () => import('@/views/Patients/Detail/index.vue')
          },
          {
            path: '/patients/:sn/report',
            name: '患者检查报告',
            meta: { requiresAuth: true, roles: ['r_admin', 'r_doctor'] },
            component: () => import('@/views/Report/index.vue')
          },
        ]
      },
      {
        path: '/devices',
        name: '设备管理',
        meta: { requiresAuth: true, roles: ['r_admin', 'r_doctor'] },
        component: () => import('@/views/Devices/index.vue')
      },
      {
        path: '/hospitals',
        name: '医院管理',
        meta: { requiresAuth: true, roles: ['r_admin'] },
        component: () => import('@/views/Hospitals/index.vue')
      },
      {
        path: '/users',
        name: '账户管理',
        meta: { requiresAuth: true, roles: ['r_admin'] },
        component: () => import('@/views/Users/index.vue')
      },
      {
        path: '/settings',
        name: '系统管理',
        redirect: '/settings/profile',
        meta: { requiresAuth: true },
        children: [
          {
            path: '/settings/profile',
            name: '个人信息',
            meta: { requiresAuth: true, roles: ['r_admin', 'r_doctor'] },
            component: () => import('@/views/Settings/Profile/index.vue')
          },
          {
            path: '/settings/password',
            name: '修改密码',
            meta: { requiresAuth: true, roles: ['r_admin', 'r_doctor'] },
            component: () => import('@/views/Settings/Password/index.vue')
          },
          {
            path: '/settings/data-management',
            name: '数据管理',
            redirect: '/settings/data-management/image-archive',
            meta: { requiresAuth: true },
            children: [
              {
                path: '/settings/data-management/image-archive',
                name: '图片归档',
                meta: { requiresAuth: true, roles: ['r_admin'] },
                component: () => import('@/views/Settings/DataManagement/ImageArchive/index.vue')
              }
            ]
          }
        ]
      },
      {
        path: '/403',
        component: () => import('@/views/403.vue')
      },
      {
        path: '/404',
        component: () => import('@/views/404.vue')
      },
      { path: '/:path(.*)', redirect: '/404' }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  const profile = JSON.parse(localStorage.getItem('profile'))

  if (token) {
    if (to.path === '/login') {
      next({ name: '首页' })
    } else if (to.meta && to.meta.roles) {
      if (to.meta.roles?.includes(profile?.roleCode)) {
        next() // 角色匹配，允许进入
      } else {
        ElMessage.info('无权限访问')
        next(false)
      }
    } else {
      next() // 无角色限制，允许进入
    }
  } else if (to.path !== '/login') {
    next({ name: '登录' })
  } else {
    next()
  }
})

export default router
